"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildNRMetaNode = buildNRMetaNode;
exports.canImportReplayAgg = canImportReplayAgg;
exports.hasReplayPrerequisite = hasReplayPrerequisite;
exports.isPreloadAllowed = isPreloadAllowed;
var _config = require("../../../common/config/config");
var _featureGates = require("../../utils/feature-gates");
var _runtime = require("../../../common/constants/runtime");
function hasReplayPrerequisite(agentId) {
  return !!_config.originals.MO &&
  // Session Replay cannot work without Mutation Observer
  (0, _featureGates.canEnableSessionTracking)(agentId) &&
  // requires session tracking to be running (hence "session" replay...)
  (0, _config.getConfigurationValue)(agentId, 'session_trace.enabled') === true; // Session Replay as of now is tightly coupled with Session Trace in the UI
}
function isPreloadAllowed(agentId) {
  return (0, _config.getConfigurationValue)(agentId, 'session_replay.preload') === true && hasReplayPrerequisite(agentId);
}
function canImportReplayAgg(agentId, sessionMgr) {
  if (!hasReplayPrerequisite(agentId)) return false;
  return !!sessionMgr?.isNew || !!sessionMgr?.state.sessionReplayMode; // Session Replay should only try to run if already running from a previous page, or at the beginning of a session
}
function buildNRMetaNode(timestamp, timeKeeper) {
  const correctedTimestamp = timeKeeper.correctAbsoluteTimestamp(timestamp);
  return {
    originalTimestamp: timestamp,
    correctedTimestamp,
    timestampDiff: timestamp - correctedTimestamp,
    originTime: _runtime.originTime,
    correctedOriginTime: timeKeeper.correctedOriginTime,
    originTimeDiff: Math.floor(_runtime.originTime - timeKeeper.correctedOriginTime)
  };
}